import { useEffect, useState, useMemo } from "react";
import { Button, Icon } from "semantic-ui-react";
import { useNavigate, Link } from "react-router-dom";
import { ReactTable, LoadingWrapper, SelectColumnFilter, SelectFilterType } from "../../common";
import { formatDateToMmDdYyyy } from "../../../utils/formatDate";
import PropTypes from "prop-types";
import { useAuth } from "../../auth";


const UtilityStrikeFormsContent = ({ utilityStrikeForms, userTeams }) => {
	const [formsArray, setFormsArray] = useState([]);
	const [loaded, setLoaded] = useState(false);
	const navigate = useNavigate();
	const { isReadOnly } = useAuth();

	const teamNames = useMemo(() => {
		return userTeams ? userTeams.map(team => team.name) : [];
	}, [userTeams]);

	useEffect(() => {
		setLoaded(false);
		if (utilityStrikeForms && typeof utilityStrikeForms === "object") {
			const arr = Object.keys(utilityStrikeForms).map((formId) => {
				const form = utilityStrikeForms[formId];
				return {
					...form,
					formId,
					status: form.submissionTime === null ? "Draft" : "Submitted"
				};
			});
			setFormsArray(arr);
		} else {
			setFormsArray([]);
		}
		setLoaded(true);
	}, [utilityStrikeForms]);

	const columns = useMemo(() => [
		{
			Header: "Form ID",
			accessor: "formId",
			Cell: (row) => (
				<Link to={`/forms/utilitystrike/${row.row.original.formId}`}>{row.row.original.formId}</Link>
			),
		},
		{
			Header: "Team Name",
			accessor: "teamName",
			Filter: row => SelectColumnFilter(row, teamNames),
			filter: SelectFilterType,
			Cell: (row) => row.row.original.teamName,
		},
		{
			Header: "Date",
			accessor: "date",
			Cell: (row) => formatDateToMmDdYyyy(row.row.original.damageDateTime),
		},
		{
			Header: "Status",
			accessor: "status",
			Filter: row => SelectColumnFilter(row, ["Draft", "Submitted"]),
			filter: SelectFilterType,
			Cell: (row) => (row.row.original.submissionTime === null ? "Draft" : "Submitted"),
		},
	], [teamNames]);

	return (
		<LoadingWrapper loading={!loaded} text="Loading Utility Strike forms">
			<div>
				<ReactTable
					className="channel-table"
					data={formsArray}
					columns={columns}
					editable={false}
				/>
				<div style={{ padding: "1rem 0", display: "flex", justifyContent: "center", width: "100%" }}>
					{!isReadOnly && (
						<Button
							style={{ backgroundColor: "var(--add)", color: "white" }}
							onClick={() => navigate("/forms/utilitystrike/new")}
							icon
							labelPosition="left"
						>
							<Icon name="plus" />
							Create New Utility Strike Form
						</Button>
					)}
				</div>
			</div>
		</LoadingWrapper>
	);
};

UtilityStrikeFormsContent.propTypes = {
	utilityStrikeForms: PropTypes.object,
	userTeams: PropTypes.array,
};

export default UtilityStrikeFormsContent;
